import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  height: 100%;
  gap: 8px;
`;

const ButtonContainer = styled.div`
  margin-top: 24px;
`;

const S = {
  Container,
  ButtonContainer,
};

export default S;
